import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A blockchain-backed Redux clone in 105 lines of code",
  "description": "",
  "published": "2017-12-18T00:00:00.000Z",
  "redirect_from": ["/blog/blockchain-backed-redux-clone-105-lines-code/swizec/7980"],
  "categories": "blockchain, Livecoding, redux, Technical",
  "hero": "./img/max-1600-1pbyFH4U5sO27UE1EjnImoA.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "kVLrT92US4U",
      "videostartat": "0"
    }}></lite-youtube>
    <p><em parentName="p"><strong parentName="em">{`Big fat disclaimer: This is Part 1 of an experiment. It is not yet secure, it does not yet share the blockchain between nodes, it still needs a proof-of-work or proof-of-stake algorithm.`}</strong></em></p>
    <p>{`With that out of the way, let us begin.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Redux is great because it does immutability right?`}<br parentName="p"></br><br parentName="p"></br>{`Now imagjne this: Blockchain backed Redux. Every state change gets recorded to the blockchain. Immutable forever. Pure as dew 👌`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/938983218975449088"
      }}>{`December 8, 2017`}</a></blockquote>
    <p>{`Redux is great because it keeps a chain of immutable data forever. What if we backed that chain with a blockchain? What would happen? 🤔`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/12/carbon-blockchain.png",
        "alt": "Blockchain in a nutshell"
      }}></img></p>
    <p>{`So I fired up `}<a parentName="p" {...{
        "href": "https://medium.com/@lhartikk/a-blockchain-in-200-lines-of-code-963cc1cc0e54"
      }}>{`this amazing Medium post`}</a>{` on building a blockchain in 200 lines of code and built a blockchain-backed Redux clone in about 2 hours.`}</p>
    <p>{`Mine is just 105 lines tho 😛`}</p>
    <p>{`You can see the `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/blockchain-redux"
      }}>{`code on Github`}</a>{`. It's not quite useful yet. The blockchain doesn't get shared between nodes, and there's no proof-of-stake or proof-of-work algorithm.`}</p>
    <p>{`That's all coming soon. First, I wanted to make sure I understood both `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Blockchain"
      }}>{`blockchains`}</a>{` and Redux enough to make this work.`}</p>
    <h2 {...{
      "id": "blockchain"
    }}>{`Blockchain`}</h2>
    <p>{`Turns out blockchains are pretty simple. It's just a reversed linked list where every node holds some data, a hash, and points to the previous node.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "817px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/0dd273654aefc8ee3d52003571f2d304/98314/max-1600-1pbyFH4U5sO27UE1EjnImoA.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "23.318385650224215%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'94\\'%20viewBox=\\'0%200%20400%2094\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M8%2012v36l1%2034h96V61h3l4-1h-7V11H57L8%2012m143%2026v36l1%208h96V62l9%202a1492%201492%200%200030%204h7v7l1%207h95V11h-96v56l-4-1-22-3-19-3-1-24V11h-97v27M11%2047v33h91V70l1-10H93l4-1h5V13H11v34m143-8c0%2024%200%2026%202%2026v1c-2%200-2%201-2%207v7h91v-9c0-10%200-9-8-10l-8-2c-3%200-3%200-2%202%203%203%202%204-1%201-4-4-4-5%200-6l4-1c-3%202-3%203%204%203l9%202h2V13h-91v26m143%201v27l2%201%203%201h-3c-2%200-2%200-2%206v5h91V13h-91v27\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0dd273654aefc8ee3d52003571f2d304/ca0a1/max-1600-1pbyFH4U5sO27UE1EjnImoA.webp 223w", "/static/0dd273654aefc8ee3d52003571f2d304/75680/max-1600-1pbyFH4U5sO27UE1EjnImoA.webp 445w", "/static/0dd273654aefc8ee3d52003571f2d304/57fc4/max-1600-1pbyFH4U5sO27UE1EjnImoA.webp 817w"],
                "sizes": "(max-width: 817px) 100vw, 817px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0dd273654aefc8ee3d52003571f2d304/e92b6/max-1600-1pbyFH4U5sO27UE1EjnImoA.png 223w", "/static/0dd273654aefc8ee3d52003571f2d304/e66bf/max-1600-1pbyFH4U5sO27UE1EjnImoA.png 445w", "/static/0dd273654aefc8ee3d52003571f2d304/98314/max-1600-1pbyFH4U5sO27UE1EjnImoA.png 817w"],
                "sizes": "(max-width: 817px) 100vw, 817px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0dd273654aefc8ee3d52003571f2d304/98314/max-1600-1pbyFH4U5sO27UE1EjnImoA.png",
                "alt": "Image borrowed from Lauri Hartikka's post",
                "title": "Image borrowed from Lauri Hartikka's post",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Image borrowed from Lauri Hartikka's post`}</figcaption>{`
  `}</figure></p>
    <p>{`We use the hashes to verify our chain. Verification is important when we start sharing chains between nodes.`}</p>
    <p>{`Our blocks are JavaScript objects.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class Block {
  constructor({ previousBlock, data }) {
    this.index = previousBlock.index + 1;
    this.previousHash = previousBlock.hash.toString();
    this.timestamp = new Date().getTime() / 1000;
    this.data = data;

    this.hash = Block.calculateHash(this);
  }

  set data(data) {
    this._data = JSON.stringify(data);
  }

  get data() {
    return JSON.parse(this._data);
  }

  // this is where a Proof-of-Work or Proof-of-Stake algo comes in, I think
  static calculateHash(block) {
    return CryptoJS.SHA256(
      block.index + block.previousHash + block.timestamp + block._data
    ).toString();
  }
}
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`constructor`}</inlineCode>{` doubles as our block generator. It takes the `}<inlineCode parentName="p">{`previousBlock`}</inlineCode>{` and some `}<inlineCode parentName="p">{`data`}</inlineCode>{`, adds some metadata, and calculates a `}<inlineCode parentName="p">{`hash`}</inlineCode>{`.`}</p>
    <p>{`A `}<inlineCode parentName="p">{`data`}</inlineCode>{` setter and getter help us JSONify data transparently. Users can pass simple objects as data, and the blockchain will handle it.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`calculateHash`}</inlineCode>{` function right now just uses SHA256, but I think this is where a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Proof-of-work_system"
      }}>{`proof of work`}</a>{` or a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Proof-of-stake"
      }}>{`proof of stake`}</a>{` algorithm would come into play in a real blockchain. Haven't figured that part out yet :)`}</p>
    <p>{`Kind of surprisingly, that's all we need to build a blockchain. You could build it like this `}<inlineCode parentName="p">{`new Block({ previousBlock: new Block({ previousBlock: genesisBlock, data: {hai: "world"}}), data: {hai2: "world2"}})`}</inlineCode></p>
    <p>{`But that's cumbersome, so let's add a Redux.`}</p>
    <h2 {...{
      "id": "redux"
    }}>{`Redux`}</h2>
    <p>{`Redux, if you don't know, is a state management approach based on the functional concept of a `}<inlineCode parentName="p">{`reducer`}</inlineCode>{`. At each change, we take the current state and a change descriptor, and produce the next state.`}</p>
    <p>{`A tiny Redux implementation that maintains history would look something like this 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function createStore(initialState, reducer) {
  let state = [initialState];

  function getState() {
    return state[state.length - 1];
  }

  function dispatch(action) {
    state.push(reducer(getState(), action));
  }

  return {
    getState: getState,
    dispatch: dispatch,
  };
}
`}</code></pre>
    <p>{`👆 That's Redux in a nutshell. Unlike the real Redux, this one maintains history. We'll expand that into a blockchain.`}</p>
    <p><inlineCode parentName="p">{`getState`}</inlineCode>{` returns the latest state and `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` takes an `}<inlineCode parentName="p">{`action`}</inlineCode>{` and calculates the new state using the `}<inlineCode parentName="p">{`reducer`}</inlineCode>{` function.`}</p>
    <p>{`Using this Redux to implement a counter looks like this 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const store = createStore({ counter: 0 }, rootReducer);

function rootReducer(state, action) {
  switch (action.type) {
    case "inc":
      return { counter: state.counter + 1 };
    case "dec":
      return { counter: state.counter - 1 };
    default:
      return state;
  }
}
`}</code></pre>
    <p>{`We can use this to verify that it works. Using tape in this case because `}<a parentName="p" {...{
        "href": "https://twitter.com/lukeed05"
      }}>{`LukeEd05`}</a>{` on the livestream suggested it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`test("count to 5", (t) => {
  for (let i = 0; i < 5; i++) {
    store.dispatch({ type: "inc" });
  }

  t.equal(store.getState().counter, 5);
  t.end();
});
`}</code></pre>
    <p>{`Works 👌`}</p>
    <h2 {...{
      "id": "blockchain-redux"
    }}>{`blockchain-redux`}</h2>
    <p>{`Now, how do we add the blockchain? 🤔`}</p>
    <p>{`Well, instead of putting `}<inlineCode parentName="p">{`initialState`}</inlineCode>{` directly into our state, we put a genesis Block with that state. And instead of pushing new state calculations directly, we add blocks.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function createStore(initialState, reducer) {
  let blockchain = [
    new Block({
      previousBlock: {
        index: 0,
        hash: "0",
        timestamp: new Date().getTime(),
      },
      data: initialState,
    }),
  ];

  function getLastBlock() {
    return blockchain[blockchain.length - 1];
  }

  function dispatch(action) {
    const lastBlock = getLastBlock();
    const nextData = reducer(lastBlock.data, action);

    addBlock(new Block({ previousBlock: lastBlock, data: nextData }));
  }

  function addBlock(newBlock) {
    if (isValidNewBlock(newBlock, getLastBlock())) {
      blockchain.push(newBlock);
    }
  }

  function isValidNewBlock(newBlock, previousBlock) {
    if (previousBlock.index + 1 !== newBlock.index) {
      console.log("invalid index");
      return false;
    } else if (previousBlock.hash !== newBlock.previousHash) {
      console.log("invalid previoushash");
      return false;
    } else if (Block.calculateHash(newBlock) !== newBlock.hash) {
      console.log(
        "invalid hash: ",
        Block.calculateHash(newBlock),
        newBlock.hash
      );
      return false;
    }
    return true;
  }

  function isValidChain(blockchain) {
    for (let i = 0; i < blockchain.length - 1; i++) {
      if (!isValidNewBlock(blockchain[i + 1], blockchain[i])) {
        return false;
      }
    }
    return true;
  }

  function replaceChain(newBlocks) {
    if (isValidChain(newBlocks) && newBlocks.length > blockchain.length) {
      blockchain = newBlocks;
      // tell others here
    }
  }

  return {
    getState: () => getLastBlock().data,
    getLastBlock: getLastBlock,
    dispatch: dispatch,
    addBlock: addBlock,
    replaceChain: replaceChain, // primarily used when starting up to take latest available blockchain
    _blockchain: blockchain,
  };
}
`}</code></pre>
    <p>{`Okay that's plenty of code to spring on you. Let's go through it function by function.`}</p>
    <h3 {...{
      "id": "getstate"
    }}>{`getState`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function getLastBlock() {
  return blockchain[blockchain.length - 1];
}
`}</code></pre>
    <p>{`Takes last block from the blockchain and returns it. That's our current state. We export a helper `}<inlineCode parentName="p">{`getState`}</inlineCode>{` that does `}<inlineCode parentName="p">{`getLastBlock().data`}</inlineCode>{` to avoid changing external APIs.`}</p>
    <h3 {...{
      "id": "dispatch"
    }}>{`Dispatch`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function dispatch(action) {
  const lastBlock = getLastBlock();
  const nextData = reducer(lastBlock.data, action);

  addBlock(new Block({ previousBlock: lastBlock, data: nextData }));
}
`}</code></pre>
    <p>{`Same as `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` before. Takes current state and builds new state with the `}<inlineCode parentName="p">{`reducer`}</inlineCode>{`. Then it uses `}<inlineCode parentName="p">{`addBlock`}</inlineCode>{` to insert a newly generated block into the chain.`}</p>
    <h3 {...{
      "id": "isvalidnewblock"
    }}>{`isValidNewBlock`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function isValidNewBlock(newBlock, previousBlock) {
  if (previousBlock.index + 1 !== newBlock.index) {
    console.log("invalid index");
    return false;
  } else if (previousBlock.hash !== newBlock.previousHash) {
    console.log("invalid previoushash");
    return false;
  } else if (Block.calculateHash(newBlock) !== newBlock.hash) {
    console.log("invalid hash: ", Block.calculateHash(newBlock), newBlock.hash);
    return false;
  }
  return true;
}
`}</code></pre>
    <p>{`Every new block has to be validated. Especially because they can come from other nodes.`}</p>
    <p>{`This checks that indexes and hashes all match up so we can avoid conflicts.`}</p>
    <h3 {...{
      "id": "isvalidchain"
    }}>{`isValidChain`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function isValidChain(blockchain) {
  for (let i = 0; i < blockchain.length - 1; i++) {
    if (!isValidNewBlock(blockchain[i + 1], blockchain[i])) {
      return false;
    }
  }
  return true;
}
`}</code></pre>
    <p>{`This will be used later on in conflict resolution. It goes through an entire proposed chain and validates every block.`}</p>
    <h3 {...{
      "id": "replacechain"
    }}>{`replaceChain`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function replaceChain(newBlocks) {
  if (isValidChain(newBlocks) && newBlocks.length > blockchain.length) {
    blockchain = newBlocks;
    // tell others here
  }
}
`}</code></pre>
    <p>{`Another part of conflict resolution and node communication is replacing the whole chain. If a new valid chain comes in that's longer than what we already have, we replace our internal state with the new chain.`}</p>
    <p>{`This will be particularly useful when we boot up a new client and it needs to get the whole chain.`}</p>
    <h2 {...{
      "id": "fin"
    }}>{`Fin`}</h2>
    <p>{`That's pretty much it. A naive blockchain implementation that gives you a Redux-like API to store and manipulate data.`}</p>
    <p>{`Next I'm going to add communication between nodes, probably through Firebase, and a proof-of-stake algorithm. Then we can start building something interesting.`}</p>
    <p>{`And maybe you now understand blockchains a little better 🤓`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      